import PropTypes from 'prop-types';
import React from 'react';

import { Footer, Header, Meta } from '$partials/global';
import ModuleDispatcher from '$partials/modules/dispatcher';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const GenericPage = ({ data, domain }) => {
    const page = data?.page;

    if (!page) { return null; }

    return (
        <>
            <Meta page={page} />

            <main
                className='layout-container'
                id='main-content'>
                <Header
                    menu={data?.navigation}
                    search={data?.search}/>

                <article className='pt-60 sm:pt-75 md:pt-100'>
                    {/* Header */}
                    <header className='px-10 sm:px-15'>
                        <div className='md:pr-100'>
                            <h1 className='type-style-2 inline mr-10'>{page.title}</h1>
                        </div>
                    </header>

                    {/* Content */}
                    {(page.modules?.items?.length > 0) &&
                        <section>
                            {page.modules.items.map((module, i) => {
                                if (!module) {return null;}
                                return (
                                    <ModuleDispatcher
                                        key={i}
                                        module={module}
                                        nextTypename={page.modules.items[i + 1]?.__typename}
                                        previousTypename={page.modules.items[i - 1]?.__typename} />
                                );
                            })}
                        </section>
                    }
                </article>

                <Footer
                    domain={domain}
                    menu={data?.footer} />
            </main>
        </>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

const propTypes = {
    data: PropTypes.shape({
        page: PropTypes.shape({
            title: PropTypes.string,
            modules: PropTypes.shape({
                items: PropTypes.array
            })
        }),
        footer: PropTypes.shape({
            items: PropTypes.array
        }),
        navigation: PropTypes.object,
        search: PropTypes.object,
    }),
    domain: PropTypes.string,
};

GenericPage.propTypes = propTypes;

export default GenericPage;
